import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  viewChild
} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {GameStore} from '../../store/game.store';
import {StepsComponent} from './steps/steps.component';
import {QuestionFeedbackComponent} from '../question-feedback/question-feedback.component';
import {Subscription} from 'rxjs';
import {HintComponent} from '../hint/hint.component';
import {AnswerComponent} from '../answer/answer.component';
import {ResourcesService} from '../../services/resources.service';
import {Select, SelectChangeEvent} from 'primeng/select';
import {ScoreBarComponent} from '../score-bar/score-bar.component';

@Component({
  selector: 'gis-questions',
  imports: [ButtonModule, StepsComponent, QuestionFeedbackComponent, HintComponent, AnswerComponent, Select, ScoreBarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit, AfterViewInit, OnDestroy {

  protected readonly store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);
  private readonly cdr = inject(ChangeDetectorRef);

  readonly gmModal = viewChild<ElementRef>('gmModal');
  readonly dropdown = viewChild(Select);
  subscription: Subscription = new Subscription();
  showQuestion = false;
  ignoreDropdownChange = false;
  showDropdown = true;

  constructor() {
  }

  ngOnInit() {
    setTimeout(() => {
      // To trigger screen reader to announce question after this component is initiated
      this.showQuestion = true;
    });
  }

  ngAfterViewInit() {
    // After play another game is clicked the dropdown is not focussed and keyboard usage is incorrect. Therefore, initialize again.
    // When p-dropdown is replaced by p-select this block maybe can be removed.
    if (!this.dropdown()?.focused) {
      this.showDropdown = false;
      this.cdr.detectChanges();
      setTimeout(() => this.showDropdown = true)
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  onStop() {
    this.store.stopGame();
  }

  nextQuestion() {
    this.store.nextQuestion();
  }

  showInfo() {
    this.gmModal()?.nativeElement.show();
    this.store.setInfoModalOpen(true);
  }

  hideInfo() {
    this.store.setInfoModalOpen(false);
  }

  onDropdownChange(event: SelectChangeEvent) {
    event.originalEvent?.stopPropagation();

    if (this.ignoreDropdownChange) {
      return;
    }

    this.store.onGuess(event.value);
    this.ignoreDropdownChange = true;
    this.dropdown()?.clear();
    this.ignoreDropdownChange = false;
  }
}
